import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { AxlPanel, AxlButton, AxlModal } from "axl-reactjs-ui";

// Utils
import {
  CANCELLED_AFTER_PICKUP,
  CANCELLED_BEFORE_PICKUP,
  DISPOSABLE,
  GEOCODE_FAILED,
  GEOCODE_FAILED_DROPOFF,
  GEOCODE_FAILED_PICKUP,
  UNDELIVERABLE,
  UNSERVICEABLE,
} from "../../constants/shipmentStatus";

// Components
import { Route, Switch, withRouter } from "react-router-dom";
import { INBOUND_STATUS_COLOR_CODE } from "axl-reactjs-ui";
import ShipmentPickupInfo from "../ShipmentPickupInfo";
import ShipmentDropoffInfo from "../ShipmentDropoffInfo";
import ShipmentHistoryInfo from "../ShipmentHistoryInfo";
import ShipmentDropoffForm from "../ShipmentDropoffForm/";
import ShipmentPickupForm from "../ShipmentPickupForm/";
import ShipmentCustomerForm from "../ShipmentCustomerForm/";
import ShipmentDropoffDispatchForm from "../ShipmentDropoffDispatchForm/";
import ParcelInfo from "../ParcelInfo";
import ShipmentValueInfoForm from "../ShipmentValueInfoForm";
import ShipmentValueInfo from "../ShipmentValueInfo";
// Styles
import styles, * as E from "./styles";

import ParcelProvider from "../../providers/Parcel";
import ShipmentRequirements from "../ShipmentRequirements";
import ShipmentTimeForm from "../ShipmentTimeForm";
import { Modal } from "@material-ui/core";

@inject("userStore", "deliveryStore")
@observer
class ShipmentInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInternalId: false,
      showPickupInfoForm: false,
      showPickupStatusForm: false,
      showDropoffInfoForm: false,
      showDropoffStatusForm: false,
      showAccessCodeForm: false,
      showShipmentCustomerForm: false,
      showShipmentValueForm: false,
      showShipmentTimeForm: false
    };
  }

  openForm = (name) => () => {
    const formStateName = `show${name}Form`;
    this.setState({ [formStateName]: true });
  };

  closeForm = (name) => () => {
    const formStateName = `show${name}Form`;
    this.setState({ [formStateName]: false });
  };

  showShipmentDetail = () => {
    console.log("history is: ", this.props.match.url);
    this.props.history.push(`${this.props.match.url}/edit`);
  };

  onEditShipmentPickup = () => {
    this.props.history.push(`${this.props.match.url}/edit/shipment-pickup`);
  };

  onEditShipmentDropoff = () => {
    this.props.history.push(`${this.props.match.url}/edit/shipment-dropoff`);
  };

  render() {
    const { showInternalId } = this.state;
    const {
      shipment, dropoff, pickup, label, client, isEdit,
      userStore, deliveryStore, isBlur
    } = this.props;
    const { clientProfiles, blurCustomerInfo } = userStore;
    const { customer } = shipment;
    const inboundStatus = shipment.inbound_status || "UNSCANNED";
    const inboundStatusColor = INBOUND_STATUS_COLOR_CODE[inboundStatus];
    const isGeneralException =
      _.indexOf([UNSERVICEABLE, UNDELIVERABLE, DISPOSABLE], shipment.status) !==
      -1;
    const isCancel =
      _.indexOf(
        [CANCELLED_AFTER_PICKUP, CANCELLED_BEFORE_PICKUP],
        shipment.status
      ) !== -1;
    const isGeocodeFail =
      _.indexOf(
        [GEOCODE_FAILED, GEOCODE_FAILED_PICKUP, GEOCODE_FAILED_DROPOFF],
        shipment.status
      ) !== -1;
    const { showActualDropoffMarker } = deliveryStore;
    const shipmentPickup = {
      title: "Pickup Info:",
      status: pickup ? pickup.status : null,
      id: shipment.id,
      address: shipment.pickup_address,
      notes: shipment.pickup_note,
      is_cancelled: shipment.is_cancelled,
      remark: pickup ? pickup.remark : "-",
    };
    const clientProfile = _.find(clientProfiles, {id: shipment.client_profile_id});

    return (
      <AxlPanel style={styles.container}>
        <AxlPanel.Row col={true} style={{ width: "100%", height: "100%" }}>
          <AxlPanel.Col
            flex={0}
            style={{ padding: "15px 20px 0", marginBottom: "15px" }}
          >
            <AxlPanel.Row>
              <AxlPanel.Col>
                <div style={styles.inboundInfo}>{`Inbound Status:`}</div>
                <div
                  style={{
                    ...styles.status,
                    color: inboundStatusColor,
                  }}
                >
                  {inboundStatus}
                </div>
                {(isCancel || isGeocodeFail || isGeneralException) && (
                  <div style={{marginTop: 2}}>
                    <div>Status: </div>
                    {isCancel ? (
                      <E.TextError>{`CANCELLED`}</E.TextError>
                    ) : isGeocodeFail ? (
                      <E.TextError>{`GEOCODE FAILED`}</E.TextError>
                    ) : isGeneralException ? (
                      <E.TextError>{shipment.status}</E.TextError>
                    ) : null}
                  </div>
                )}
              </AxlPanel.Col>
              <AxlPanel.Col
                center
                style={{ paddingLeft: "15px", paddingRight: "15px" }}
              >
                <div style={{ ...styles.name, ...(isBlur && styles.textBlur) }}>
                  {label ? label.driver_label + " : " : ""}
                  {customer ? customer.name : ""}
                </div>
                <div style={styles.company}>
                  {shipment.internal_id && (
                    <code style={blurCustomerInfo ? { ...styles.code, ...styles.textBlur } : styles.code}>{shipment.internal_id}</code>
                  )}
                </div>
              </AxlPanel.Col>
              <AxlPanel.Col>
                {clientProfile && (
                  <div style={{textAlign: "right"}}>
                    <div style={{textAlign: "center", display: "inline-block"}}>
                      <img src={clientProfile.logo} alt={clientProfile.name} style={{maxWidth: 50, maxHeight: 50, ...(isBlur && styles.imgBlur)}} />
                      <div style={{...styles.company, ...(isBlur && styles.textBlur)}}>{clientProfile.name}</div>
                    </div>
                  </div>
                )}
              </AxlPanel.Col>
            </AxlPanel.Row>
            <AxlPanel.Row style={{ marginTop: "15px" }}>
              <AxlPanel.Col>
                <AxlPanel.Row>
                  <AxlPanel.Col>
                    <div style={styles.label2}>{`Customer Info:`}</div>
                    <div
                      style={{
                        ...styles.email,
                        ...(isBlur && styles.textBlur),
                      }}
                    >
                      {customer.email ? customer.email : ""}
                    </div>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              </AxlPanel.Col>
              <AxlPanel.Col style={styles.email}>
                <div style={styles.label2}>
                  <br />
                </div>
                <div
                  style={{ ...styles.phone, ...(isBlur && styles.textBlur) }}
                >
                  {customer.phone_number}
                </div>
              </AxlPanel.Col>
              {!userStore.isReadOnly && isEdit && (
                <AxlButton
                  tiny
                  bg={`none`}
                  onClick={this.openForm("ShipmentCustomer")}
                >{`Edit`}</AxlButton>
              )}
            </AxlPanel.Row>
          </AxlPanel.Col>
          <AxlPanel.Col
            flex={1}
            style={{ padding: "0 20px", height: "100%", overflowY: "scroll" }}
          >
            <ShipmentRequirements shipment={shipment} dropoff={dropoff} />
            <ShipmentValueInfo shipment={shipment} 
                openForm={this.openForm}
                isEdit={this.props.isEdit}
            />
            <ParcelProvider>
              <ParcelInfo
                shipmentId={shipment.id}
                shipment={shipment}
                workload={shipment.workload}
                assignmentId={shipment.assignment_id}
              />
            </ParcelProvider>
            <ShipmentPickupInfo
              pickup={pickup}
              dropoff={dropoff}
              shipment={shipment}
              openForm={this.openForm}
              isEdit={this.props.isEdit}
            />
            <ShipmentDropoffInfo
              pickup={pickup}
              dropoff={dropoff}
              shipment={shipment}
              closeForm={this.closeForm}
              openForm={this.openForm}
              isOpen
              isEdit={this.props.isEdit}
            />
            <ShipmentHistoryInfo
              shipment={shipment}
              shipmentHistory={this.props.shipmentHistory}
              isOpen
              showActualDropoffInfo={showActualDropoffMarker}
            />
          </AxlPanel.Col>
        </AxlPanel.Row>
        {this.state.showDropoffInfoForm && (
          <AxlModal
            onClose={this.closeForm("DropoffInfo")}
            style={styles.shipmentDetailModal}
          >
            <ShipmentDropoffForm
              shipment={shipment}
              closeForm={this.closeForm("DropoffInfo")}
            />
          </AxlModal>
        )}
        {this.state.showPickupInfoForm && (
          <AxlModal
            onClose={this.closeForm("PickupInfo")}
            style={styles.shipmentDetailModal}
          >
            <ShipmentPickupForm
              shipment={shipment}
              pickup={pickup}
              dropoff={dropoff}
              closeForm={this.closeForm("PickupInfo")}
            />
          </AxlModal>
        )}
        {this.state.showShipmentCustomerForm && (
          <AxlModal
            onClose={this.closeForm("ShipmentCustomer")}
            style={styles.shipmentDetailModal}
          >
            <ShipmentCustomerForm
              shipment={shipment}
              dropoff={dropoff}
              closeForm={this.closeForm("ShipmentCustomer")}
            />
          </AxlModal>
        )}
        {this.state.showAccessCodeForm && (
          <AxlModal
            onClose={this.closeForm("AccessCode")}
            style={styles.shipmentDetailModal}
          >
            <ShipmentDropoffDispatchForm
              shipment={shipment}
              pickup={pickup}
              dropoff={dropoff}
              closeForm={this.closeForm("AccessCode")}
            />
          </AxlModal>
        )}
        {this.state.showValueInfoForm && (
          <AxlModal
            onClose={this.closeForm("ValueInfo")}
            style={styles.shipmentValueModal}
          >
            <ShipmentValueInfoForm
              shipment={shipment}
              closeForm={this.closeForm("ValueInfo")}
            />
          </AxlModal>
        )}    
        <Modal
          open={this.state.showShipmentTimeForm}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          onClose={() => this.setState({ showShipmentTimeForm: false })}
          style={styles.shipmentTimeModal}
        >
          <ShipmentTimeForm
            shipment={shipment}
            pickup={pickup}
            dropoff={dropoff}
            closeForm={() => {
              this.setState({ showShipmentTimeForm: false })
            }}
            deliveryStore={deliveryStore}
          />
        </Modal>
      </AxlPanel>
    );
  }
}

ShipmentInfo.defaultProps = {
  isEdit: true,
};

ShipmentInfo.propTypes = {
  isEdit: PropTypes.bool,
};

export default withRouter(ShipmentInfo);
